import { h } from 'preact'
import Header from '../header'
import MethodBox from './MethodBox'
import Key from '../assets/key'
import Flag from '../ui-components/Flag'
import ButtonControl from '../button-control'

import { Provider, ProviderList } from './types'

interface Props {
  providers: ProviderList
}

const SSOOverviewPresenter = ({ providers }: Props) =>
  <div>
    <Header
      title='SSO'
      disableCancelButton
      disableSaveButton
    />
    <div class='sso-overview sso-settings'>
      <div className='sso-method-title'>SSO method</div>
      {providers.map((provider: Provider) => {
        const isInstalled = provider.isInstalled

        function getButtonProps () {
          return {
            title: isInstalled ? 'Edit' : 'Install',
            variant: isInstalled ? 'secondary' : 'primary',
            onClick: isInstalled ? () => provider.onEdit(provider) : () => provider.onInstall(provider),
            class: isInstalled ? `sso-overview__${provider.name}-edit` : `sso-overview__${provider.name}-install`
          }
        }

        return <MethodBox providerName={provider.name}>
          <Key />
          <div className={`method-${provider.name}`}>{provider.label}</div>
          {isInstalled && <Flag text='Installed' success />}
          <ButtonControl {...getButtonProps()} />
        </MethodBox>
      })}
    </div>
  </div>

export default SSOOverviewPresenter
